export default {
    count_active: '¡Activa tu cuenta!',
    days: 'días',
    expired: 'Tu suscripción ha caducado. ¡Activa tu cuenta!',
    expired_short: 'Prueba expirada',
    you_have: 'Tienes ',
    take_session: ' Para reservar tu sesión formativa gratuita.',
    take_now: ' Reserva ahora.',
}